module.exports = __webpack_public_path__ + "media/images/icons/delete_white-0dd9c69eb5f84685faf1e0ddae718859.svg";